module.exports = __webpack_public_path__ + "img/9788963702674.34eafa6a.jpg";